import React, { useState, useEffect } from 'react';
import { Card, Form, Select, Switch, Col, Row } from 'antd';

export interface PatternPointLineConfig {
    fields: string[];
    resolution: string;
    showParent: boolean;
    showPoints: boolean;
}

const DEFAULT_PATTERN_POINT_LINE_CONFIG: PatternPointLineConfig = {
    fields: [],
    resolution: 'day',
    showParent: true,
    showPoints: false,
};

interface Props {
    initialConfig?: Partial<PatternPointLineConfig>;
    fieldOptions?: Array<{ label: string; value: string }>;
    onChange: (config: PatternPointLineConfig) => void;
}

export const SectionConfigPatternPointLine: React.FC<Props> = ({ initialConfig, fieldOptions, onChange }) => {
    const [config, setConfig] = useState<PatternPointLineConfig>({
        ...DEFAULT_PATTERN_POINT_LINE_CONFIG,
        ...initialConfig,
    });

    const updateField = (field: keyof PatternPointLineConfig, value: any) => {
        const newConfig = { ...config, [field]: value };
        setConfig(newConfig);
        onChange(newConfig);  // Call onChange directly to avoid infinite loop
    };

    return (
        <Card size="small" style={{ background: '#f5f5f5' }}>
            <Form.Item label="KPI fields to show">
                <Select
                    mode="multiple"
                    allowClear
                    options={fieldOptions || []}
                    value={config.fields}
                    onChange={(vals) => updateField('fields', vals)}
                />
            </Form.Item>
            <Row gutter={12}>
                <Col span={8}>
                    <Form.Item label="Time resolution">
                        <Select
                            value={config.resolution}
                            onChange={(val) => updateField('resolution', val)}
                            options={[
                                { label: 'Hour', value: 'hour' },
                                { label: 'Day', value: 'day' },
                                { label: 'Week', value: 'week' },
                                { label: 'Month', value: 'month' },
                            ]}
                        />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label="Show parent (aggregated)">
                        <Switch
                            checked={config.showParent}
                            onChange={(checked) => updateField('showParent', checked)}
                        />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label="Show points breakdown">
                        <Switch
                            checked={config.showPoints}
                            onChange={(checked) => updateField('showPoints', checked)}
                        />
                    </Form.Item>
                </Col>
            </Row>
        </Card>
    );
};

export default SectionConfigPatternPointLine;
